{
  "addons.addonList": "Lista de complementos",
  "addons.ambientWeatherCreateAndRetrieveApiKey": "Crie e recupere sua chave de API neste link",
  "addons.ambientWeatherDescription": "Estações meteorológicas Ambient Weather (WS-5000, WS-2000, WS-2902C, …)",
  "addons.apiKey": "Chave API",
  "addons.applicationKey": "Chave da aplicação",
  "addons.connect": "Conectar",
  "addons.davisApiSecret": "API Secreta",
  "addons.davisApiV2Key": "Chave API V2",
  "addons.davisDescription": "Estações meteorológicas Davis (Vantage Vue, Vantage Pro 2, …)",
  "addons.davisRetrieveApiKey": "Recuperar as suas chaves API V2 a partir deste link",
  "addons.disconnect": "Desconectar-se",
  "addons.ecowittCreateAndRetrieveKeys": "Crie e recupere sua chave de API e chave de aplicação neste link",
  "addons.ecowittDescription": "A Ecowitt fornece estações meteorológicas profissionais, termômetros internos/externos sem fio, pluviômetros de alta precisão, sensores de qualidade do ar e muito mais.",
  "addons.helpLink": "Como conectar {provider}",
  "addons.myAcuriteAccountOnHold": "A sua conta foi colocada em espera. Por favor, introduza a sua palavra-passe para reconectar a sua conta",
  "addons.myAcuriteDescription": "AcuRite é a marca de estações meteorológicas nº 1 na América do Norte. Como líder em tecnologia de tempo, temperatura e clima, a AcuRite fornece informações detalhadas sobre o seu ambiente interno e externo para que possa planear o seu dia com confiança.",
  "addons.myAcuriteEnterCredentials": "Insira as suas credenciais My AcuRite para vincular a sua conta My AcuRite ao SmartMixin",
  "addons.netatmoEnergy": "Netatmo Energy",
  "addons.netatmoEnergyDescription": "Utilize o seu Termóstato Netatmo para mudar a temperatura da sua casa, da sua cama ou de outra parte do mundo",
  "addons.netatmoThermostat": "Termóstato Netatmo",
  "addons.netatmoWeather": "Netatmo Weather",
  "addons.netatmoWeatherDescription": "A sua estação meteorológica pessoal em casa",
  "addons.or": "ou",
  "addons.providerAccountDisconnected": "A conexão com o seu serviço meteorológico expirou. Reconecte-se para retomar as atualizações de dados.",
  "addons.reconnect": "Reconectar",
  "addons.weatherflowCreateToken": "Criar e recuperar o seu token a partir deste link",
  "addons.weatherflowTempestDescription": "Estação meteorológica Tempest com anemómetro e pluviómetro incorporados",
  "addons.wundergroundApiKey": "API key",
  "addons.wundergroundDescription": "Weather Underground é uma comunidade global de pessoas que liga dados de sensores ambientais como estações meteorológicas e monitores de qualidade do ar para que possamos fornecer os dados ricos e hiperlocais de que necessita para alimentar as suas paixões",
  "addons.wundergroundRetrieveApiKey": "Recuperar as suas chaves API a partir deste link",
  "addons.wundergroundRetrieveStationId": "Recuperar as suas Estação ID a partir deste link",
  "addons.wundergroundStationId": "Estação ID",
  "airQuality.airQuality": "Qualidade do ar",
  "airQuality.airQualityIndex": "Índice de qualidade do ar",
  "airQuality.aqiForecast": "Previsão da qualidade do ar",
  "airQuality.co": "Monóxido de carbono",
  "airQuality.dailyForecast": "Previsão diária",
  "airQuality.details": "Detalhes",
  "airQuality.dominantPollutant": "Poluente dominante",
  "airQuality.good": "Bom",
  "airQuality.goodDescription": "A qualidade do ar é considerada satisfatória, e a poluição do ar acarreta pouco ou nenhum risco",
  "airQuality.hazardous": "Perigoso",
  "airQuality.hazardousDescription": "Alerta de saúde: toda a gente pode experienciar efeitos sérios na saúde",
  "airQuality.indoorAirQuality": "Qualidade do ar interno",
  "airQuality.mgm3": "mg/m³",
  "airQuality.moderate": "Moderado",
  "airQuality.moderateDescription": "A qualidade do ar é aceitável; contudo, alguns poluentes podem ter um efeito moderado na saúde para um número muito reduzido de pessoas que são particularmente sensíveis a poluição do ar.",
  "airQuality.no2": "Dióxido de azoto",
  "airQuality.o3": "Ozono",
  "airQuality.pm10": "Partículas com um diâmetro igual ou inferior a 10 μm",
  "airQuality.pm25": "Partículas com um diâmetro igual ou inferior a 2,5 μm",
  "airQuality.ppb": "ppb",
  "airQuality.sensitiveUnhealthy": "Não saudável para pessoas sensíveis",
  "airQuality.sensitiveUnhealthyDescription": "Membros de grupos sensíveis podem experienciar efeitos na saúde. O público em geral não será afetado provavelmente.",
  "airQuality.so2": "Dióxido de enxofre",
  "airQuality.ugm3": "µg/m³",
  "airQuality.unhealthy": "Não saudável",
  "airQuality.unhealthyDescription": "Toda a gente pode começar a experienciar efeitos na saúde; membros de grupos sensíveis podem experienciar efeitos mais sérios na saúde",
  "airQuality.veryUnhealthy": "Nada saudável",
  "airQuality.veryUnhealthyDezscription": "Avisos de saúde para condições de emergência. Muito provavelmente toda a população será afetada.",
  "alerts.addAlert": "Adicionar alerta",
  "alerts.addCondition": "Adicionar condição",
  "alerts.alertAdded": "Alerta adicionado com sucesso",
  "alerts.alertAuthorizationNotice": "Os alertas funcionam apenas se autorizar a SmartMixin mostrar notificações",
  "alerts.alertDeleted": "Alerta apagado com sucesso",
  "alerts.alertEdited": "Alerta modificado com sucesso",
  "alerts.alertName": "Nome de alerta",
  "alerts.alertWhen": "Eu quero ser alertado quando:",
  "alerts.aqiGreaterThan": "AQI superior a",
  "alerts.aqiGreaterThanThreshold": "AQI superior a {value}{unit}",
  "alerts.aqiLessThan": "AQI inferior a",
  "alerts.aqiLessThanThreshold": "AQI inferior a {value}{unit}",
  "alerts.atLeastOneCondition": "Necessita de adicionar pelo menos uma condição",
  "alerts.co2GreaterThan": "CO2 superior a",
  "alerts.co2GreaterThanThreshold": "CO2 superior a {value}{unit}",
  "alerts.co2LessThan": "CO2 inferior a",
  "alerts.co2LessThanThreshold": "CO2 inferior a {value}{unit}",
  "alerts.conditions": "Condições",
  "alerts.createAlert": "Criar alerta",
  "alerts.dailyPrecipitationGreaterThan": "Precipitação diária superior a",
  "alerts.dailyPrecipitationGreaterThanThreshold": "Precipitação diária superior ao limiar de {value}{unit}",
  "alerts.deleteAlert": "Eliminar alerta",
  "alerts.editAlert": "Editar alerta",
  "alerts.editCondition": "Editar condição",
  "alerts.gustSpeedGreaterThan": "Rajada de vento superior a",
  "alerts.gustSpeedGreaterThanThreshold": "Rajada de vento superior a {value}{unit}",
  "alerts.gustSpeedLessThan": "Rajada de vento inferior a",
  "alerts.gustSpeedLessThanThreshold": "Rajada de vento inferior a {value}{unit}",
  "alerts.heatIndexGreaterThan": "Índice de calor superior a",
  "alerts.heatIndexGreaterThanThreshold": "Índice de calor superior a {value}{unit}",
  "alerts.heatIndexLessThan": "Índice de calor inferior a",
  "alerts.heatIndexLessThanThreshold": "Índice de calor inferior a {value}{unit}",
  "alerts.humidexGreaterThan": "Humidex superior a",
  "alerts.humidexGreaterThanThreshold": "Humidex superior a {value}{unit}",
  "alerts.humidexLessThan": "Humidex inferior a",
  "alerts.humidexLessThanThreshold": "Humidex inferior a {value}{unit}",
  "alerts.humidityGreaterThan": "Humidade superior a",
  "alerts.humidityGreaterThanThreshold": "Humidade superior a {value}{unit}",
  "alerts.humidityLessThan": "Humidade inferior a",
  "alerts.humidityLessThanThreshold": "Humidade inferior a {value}{unit}",
  "alerts.inProgress": "Em progresso",
  "alerts.myAlerts": "Meus alertas",
  "alerts.noConfiguredAlert": "Ainda não tem nenhum alerta configurado, adicione um",
  "alerts.noiseGreaterThan": "Ruído superior a",
  "alerts.noiseGreaterThanThreshold": "Ruído superior a {value}{unit}",
  "alerts.noiseLessThan": "Ruído inferior a",
  "alerts.noiseLessThanThreshold": "Ruído inferior a {value}{unit}",
  "alerts.noteOnConditions": "Note que o alerta é acionado quando todas as condições abaixo são verificadas",
  "alerts.noTriggerHistory": "Este alerta ainda não foi acionado.",
  "alerts.pm10GreaterThan": "PM 10 superior a",
  "alerts.pm10GreaterThanThreshold": "PM 10 superior a {value}{unit}",
  "alerts.pm10LessThan": "PM 10 inferior a",
  "alerts.pm10LessThanThreshold": "PM 10 inferior a {value}{unit}",
  "alerts.pm1GreaterThan": "PM 1 superior a",
  "alerts.pm1GreaterThanThreshold": "PM 1 superior a {value}{unit}",
  "alerts.pm1LessThan": "PM 1 inferior a",
  "alerts.pm1LessThanThreshold": "PM 1 inferior a {value}{unit}",
  "alerts.pm2p5GreaterThan": "PM 2.5 superior a",
  "alerts.pm2p5GreaterThanThreshold": "PM 2.5 superior a {value}{unit}",
  "alerts.pm2p5LessThan": "PM 2.5 inferior a",
  "alerts.pm2p5LessThanThreshold": "PM 2.5 inferior a {value}{unit}",
  "alerts.postStormSummary": "Resumo da tempestade",
  "alerts.postStormSynopsisHelper": "Receberá uma notificação de resumo no final de cada tempestade de chuva.",
  "alerts.postStormSynopsisSoleCondition": "Um resumo pós-tempestade não pode ser combinado com outras condições.",
  "alerts.precipitationGreaterThan": "Precipitação horária superior a",
  "alerts.precipitationGreaterThanThreshold": "Precipitação horária superior ao limiar de {value}{unit}",
  "alerts.pressureGreaterThan": "Pressão atmosférica superior a",
  "alerts.pressureGreaterThanThreshold": "Pressão atmosférica superior a {value}{unit}",
  "alerts.pressureLessThan": "Pressão atmosférica inferior a",
  "alerts.pressureLessThanThreshold": "Pressão atmosférica inferior a {value}{unit}",
  "alerts.rainRateGreaterThan": "Intensidade de chuva superior a",
  "alerts.rainRateGreaterThanThreshold": "Intensidade de chuva superior ao limiar de {value}{unit}",
  "alerts.solarRadiationGreaterThan": "Radiação solar superior a",
  "alerts.solarRadiationGreaterThanThreshold": "Radiação solar superior a {value}{unit}",
  "alerts.solarRadiationLessThan": "Radiação solar inferior a",
  "alerts.solarRadiationLessThanThreshold": "Radiação solar inferior a {value}{unit}",
  "alerts.stormChartUnavailable": "O histórico de chuva desta tempestade não está disponível.",
  "alerts.stormDetail": "Resumo da tempestade",
  "alerts.stormDuration": "Duração",
  "alerts.stormEnd": "Fim",
  "alerts.stormPeakRate": "Intensidade máxima de chuva",
  "alerts.stormStart": "Início",
  "alerts.stormTotal": "Chuva total",
  "alerts.temperatureGreaterThan": "Temperatura superior a",
  "alerts.temperatureGreaterThanThreshold": "Temperatura superior a {value}{unit}",
  "alerts.temperatureLessThan": "Temperatura inferior a",
  "alerts.temperatureLessThanThreshold": "Temperatura inferior a {value}{unit}",
  "alerts.thswGreaterThan": "THSW superior a",
  "alerts.thswGreaterThanThreshold": "THSW superior a {value}{unit}",
  "alerts.thswLessThan": "THSW inferior a",
  "alerts.thswLessThanThreshold": "THSW inferior a {value}{unit}",
  "alerts.thwGreaterThan": "THW superior a",
  "alerts.thwGreaterThanThreshold": "THW superior a {value}{unit}",
  "alerts.thwLessThan": "THW inferior a",
  "alerts.thwLessThanThreshold": "THW inferior a {value}{unit}",
  "alerts.triggerHistory": "Histórico do alerta",
  "alerts.uvGreaterThan": "Índice UV superior a",
  "alerts.uvGreaterThanThreshold": "Índice UV superior a {value}{unit}",
  "alerts.uvLessThan": "Índice UV inferior a",
  "alerts.uvLessThanThreshold": "Índice UV inferior a {value}{unit}",
  "alerts.visibilityGreaterThanThreshold": "Visibilidade superior a {value}{unit}",
  "alerts.visibilityLessThanThreshold": "Visibilidade inferior a {value}{unit}",
  "alerts.visiblityGreaterThan": "Visibilidade superior a",
  "alerts.visiblityLessThan": "Visibilidade inferior a",
  "alerts.whichMeasure": "Para que medida gostaria de ser alertado?",
  "alerts.whichModule": "Para que módulo gostaria de ser alertado?",
  "alerts.windChillGreaterThan": "Resfriamento do Vento superior a",
  "alerts.windChillGreaterThanThreshold": "Resfriamento do Vento superior a {value}{unit}",
  "alerts.windChillLessThan": "Resfriamento do Vento inferior a",
  "alerts.windChillLessThanThreshold": "Resfriamento do Vento inferior a {value}{unit}",
  "alerts.windSpeedGreaterThan": "Velocidade do vento superior a",
  "alerts.windSpeedGreaterThanThreshold": "Velocidade do vento superior a {value}{unit}",
  "alerts.windSpeedLessThan": "Velocidade do vento inferior a",
  "alerts.windSpeedLessThanThreshold": "Velocidade do vento inferior a {value}{unit}",
  "astral.astronomicalSunPhase": "Astronómico {sunPhase}",
  "astral.civilSunPhase": "Civil {sunPhase}",
  "astral.dawn": "Amanhecer",
  "astral.dusk": "Crepúsculo",
  "astral.firstQuarter": "Quarto crescente",
  "astral.fullMoon": "Lua cheia",
  "astral.lastQuarter": "Quarto decrescente",
  "astral.moon": "Lua",
  "astral.moonPhases": "Fases da lua",
  "astral.moonrise": "Nascer da lua",
  "astral.moonset": "Pôr da lua",
  "astral.nauticalSunPhase": "Náutico {sunPhase}",
  "astral.newMoon": "Lua nova",
  "astral.noon": "Meio-dia",
  "astral.remainingDaylight": "Luz do dia remanescente",
  "astral.sunrise": "Nascer do sol",
  "astral.sunriseAndSunset": "Nascer do sol e pôr do sol",
  "astral.sunriseAt": "Nascer do sol às {time}",
  "astral.sunset": "Pôr do sol",
  "astral.sunsetAt": "Pôr do sol às {time}",
  "astral.totalDaylight": "Luz do dia total",
  "astral.waningCrescent": "último crescente",
  "astral.waningGibbous": "lua minguante",
  "astral.waxingCrescent": "Primeiro Crescente",
  "astral.waxingGibbous": "Lua crescente",
  "auth.alreadyHaveAccount": "Já tem uma conta?",
  "auth.authContainerTagline": "O seu painel meteorológico pessoal. Conecte as suas estações e obtenha dados em tempo real na ponta dos dedos.",
  "auth.backToLogin": "Voltar ao login",
  "auth.catchPhrase": "A Plataforma de Inteligência Meteorológica",
  "auth.checkYourEmail": "Verifique o seu email",
  "auth.continueWithApple": "Continuar com Apple",
  "auth.continueWithFacebook": "Continuar com Facebook",
  "auth.continueWithGoogle": "Continuar com Google",
  "auth.email": "Endereço de email",
  "auth.emailRequiredLoginFacebook": "A permissão de email é requerida.",
  "auth.emailVerification": "Verificação de e-mail",
  "auth.emailVerificationFailure": "Ocorreu um problema com a sua verificação de email.",
  "auth.emailVerificationSuccess": "O seu email foi verificado com sucesso.",
  "auth.firstName": "Nome",
  "auth.forgotPassword": "Esqueceu a sua palavra-passe?",
  "auth.forgotPasswordSubtitle": "Insira o seu email e enviaremos um link para redefinir a sua palavra-passe.",
  "auth.lastName": "Apelido",
  "auth.login": "Entrar",
  "auth.loginSubtitle": "Bem-vindo de volta! Por favor, insira os seus dados.",
  "auth.loginToSmartMixinDescription": "Insira as suas credenciais SmartMixin para aceder à sua conta.",
  "auth.logout": "Sair",
  "auth.logoutConfirmation": "Tem a certeza de que deseja desconectar?",
  "auth.noAccountYet": "Ainda não tem uma conta?",
  "auth.or": "ou",
  "auth.password": "Palavra-passe",
  "auth.passwordAgain": "Confirmar palavra-passe",
  "auth.passwordReset": "Redefinição de palavra-passe",
  "auth.passwordResetSuccess": "Redefinição com sucesso da palavra-passe",
  "auth.register": "Criar conta",
  "auth.registerDescription": "Crie uma conta SmartMixin gratuita para conectar as suas estações meteorológicas, acompanhar dados do tempo e aceder a ferramentas de análise poderosas.",
  "auth.registerSubtitle": "Crie a sua conta para começar.",
  "auth.registerSuccess": "Você registou-se com sucesso! Nós enviámos-lhe um link de verificação para {emailAddress}",
  "auth.restorePassword": "Restaurar palavra-passe",
  "auth.restorePasswordSuccess": "Nós enviámos-lhe um link de redefinição de palavra-passe para {emailAddress} com mais instruções.",
  "auth.sendReset": "Enviar instruções de redefinição.",
  "auth.signInWithApple": "",
  "auth.socialAccount": "ou utlize a sua conta",
  "auth.welcome": "Bem-vindo a SmartMixin",
  "auth.welcomeBack": "Bem-vindo de novo!",
  "calendar.april": "Abril",
  "calendar.august": "Agosto",
  "calendar.dateFormat": "Formato de data",
  "calendar.day": "Dia",
  "calendar.december": "Dezembro",
  "calendar.end": "Fim",
  "calendar.february": "Fevereiro",
  "calendar.hours": "Horas",
  "calendar.hoursShort": "h",
  "calendar.january": "Janeiro",
  "calendar.july": "Julho",
  "calendar.june": "Junho",
  "calendar.last24Hours": "últimas 24 horas",
  "calendar.last30Days": "últimos 30 dias",
  "calendar.last7Days": "Últimos 7 dias",
  "calendar.march": "Março",
  "calendar.max": "Max",
  "calendar.may": "Maio",
  "calendar.month": "Mês",
  "calendar.months": "Meses",
  "calendar.november": "Novembro",
  "calendar.october": "Outubro",
  "calendar.oneDay": "1 dia",
  "calendar.oneHour": "1 hora",
  "calendar.oneMonth": "1 mês",
  "calendar.oneWeek": "1 semana",
  "calendar.previous24Hours": "As 24 horas anteriores",
  "calendar.previous30Days": "Os 30 dias anteriores",
  "calendar.previous7Days": "Os 7 dias anteriores",
  "calendar.previousDay": "Dia anterior",
  "calendar.previousMonth": "Mês anterior",
  "calendar.previousWeek": "Semana anterior",
  "calendar.previousYear": "Ano anterior",
  "calendar.sameDayLastYear": "Mesmo dia do ano passado",
  "calendar.sameMonthLastYear": "Mesmo mês do ano passado",
  "calendar.selectADate": "Selecione uma data",
  "calendar.selectAggregation": "Selecionar o valor exibido",
  "calendar.selectAMonth": "Selecione um mês",
  "calendar.selectAYear": "Selecione um ano",
  "calendar.selectGranularity": "Selecionar granularidade",
  "calendar.selectTimescale": "Selecionar uma escala de tempo",
  "calendar.september": "Setembro",
  "calendar.sixHours": "6 horas",
  "calendar.start": "Começo",
  "calendar.thirtyMinutes": "30 min",
  "calendar.threeHours": "3 horas",
  "calendar.use24HourFormat": "Utilizar o formato 24 horas",
  "calendar.week": "Semana",
  "calendar.year": "Ano",
  "calendar.yesterday": "Ontem",
  "common.accountDeleted": "A sua conta foi eliminada com sucesso.",
  "common.accountOnHold": "A conexão da sua conta expirou. Reconecte-se para retomar as atualizações de dados.",
  "common.add": "Adicionar",
  "common.addAStation": "Adicionar estação",
  "common.addToFavorites": "Adicionar aos favoritos",
  "common.addYourOwnStation": "Adicione a sua estação",
  "common.alreadyPremium": "Já tem uma conta premium!",
  "common.alsoAvailableOn": "Também disponível em:",
  "common.altitude": "Altitude",
  "common.analysis": "Análise",
  "common.aroundMe": "Perto de mim",
  "common.articleCount": "{count, plural, one {# artigo} other {# artigos}}",
  "common.articleNotFound": "Artigo não encontrado",
  "common.articleNotFoundDescription": "O artigo que procura não existe.",
  "common.average": "Média",
  "common.averageOverThePeriod": "Média ao longo do período",
  "common.away": "Ausente",
  "common.back": "Voltar",
  "common.backToHelpCenter": "Voltar à central de ajuda",
  "common.backToHome": "Voltar ao Início",
  "common.bad": "Mau",
  "common.batteryLevel": "Nível de bateria",
  "common.bestValue": "Melhor Valor",
  "common.billingDetailsAndroid": "Na oferta de experimentação gratuita, não será facturado se cancelar 24 horas antes de expirar. Quando o período de experimentação terminar, pode cancelar a subscrição no SmartMixin em qualquer momento nas configurações da sua conta Google Play, ou será renovada automaticamente. Isto tem de ser feito 24 horas antes do fim do período de subscrição para evitar que sejam cobradas outras taxas mostradas no botão acima. Os pagamentos de subscrição serão cobrados na sua conta Google Play na confirmação da sua compra e no início de cada período de renovação.",
  "common.billingDetailsIos": "Na oferta de experimentação gratuita, não será facturado se cancelar 24 horas antes de expirar. Quando o período de experimentação terminar, pode cancelar a subscrição no SmartMixin em qualquer momento nas configurações da sua conta App Store, ou será renovada automaticamente. Isto tem de ser feito 24 horas antes do fim do período de subscrição para evitar que sejam cobradas outras taxas mostradas no botão acima. Os pagamentos de subscrição serão cobrados na sua conta da App Store na confirmação da sua compra e no início de cada período de renovação.",
  "common.boilerOn": "Em aquecimento",
  "common.browseByCategory": "Navegar por categoria",
  "common.calendarView": "Visualização de calendário",
  "common.cancel": "Cancelar",
  "common.cannotBeEmpty": "Este campo não pode estar vazio.",
  "common.cardDetails": "Detalhes do cartão",
  "common.categoryNotFound": "Categoria não encontrada",
  "common.categoryNotFoundDescription": "Esta categoria não existe ou não tem artigos.",
  "common.charts": "Gráficos",
  "common.chartView": "Visualização de gráfico",
  "common.clearRecentLocations": "Limpar tudo",
  "common.close": "Fechar",
  "common.comparison": "Comparação",
  "common.contactMe": "Entre em contato comigo",
  "common.currentDay": "Hoje",
  "common.currentLocation": "Localização atual",
  "common.currentObservations": "Observações atuais",
  "common.currentRainEvent": "Evento de chuva atual",
  "common.currentRate": "intensidade da chuva",
  "common.currentWeatherConditions": "Condições atuais",
  "common.customizeComparisonMetrics": "Personalizar métricas",
  "common.customizeComparisonMetricsDescription": "Arraste os itens para reordenar suas métricas de comparação. Toque no ícone de olho para mostrar ou ocultar métricas.",
  "common.customizeDashboard": "Personalizar",
  "common.customizeDashboardDescription": "Arraste os itens para reordenar o seu painel. Toque no ícone do olho para mostrar ou ocultar secções.",
  "common.customizedStationName": "Nome de estação personalizado",
  "common.dailyForecast": "Previsão diária",
  "common.dashboard": "Painel de controlo",
  "common.default": "Padrão",
  "common.defaultForecastModelChip": "Padrão · {name}",
  "common.delete": "Apagar",
  "common.deleteAccount": "Eliminar conta",
  "common.deleteAccountConfirmation": "Tem a certeza de que deseja eliminar a sua conta? Esta ação é irreversível.",
  "common.deleteAccountDescription": "Esta ação elimina a sua conta e todas as suas informações. Não há retorno.",
  "common.details": "Detalhes",
  "common.edit": "Editar",
  "common.editor": "Editor",
  "common.endTime": "Fim",
  "common.exitFullscreen": "Sair do ecrã inteiro",
  "common.exploreWeatherMap": "Explorar Mapa do Tempo",
  "common.favoriteLocations": "Favoritos",
  "common.favoriteLocationsEmpty": "Pode adicionar até 5 locais favoritos.",
  "common.favoriteStations": "Estações favoritas",
  "common.feedbackHelpsImprove": "A sua opinião ajuda-nos a melhorar os nossos artigos de ajuda.",
  "common.feedbackReasonNotAnswer": "Não responde à minha pergunta",
  "common.feedbackReasonOutdated": "As informações estão desatualizadas",
  "common.feedbackReasonUnclear": "As instruções não são claras",
  "common.feedbackWhatWentWrong": "Qual foi o problema?",
  "common.filterStationDescription": "Não exiba estações com medições não confiáveis",
  "common.filterStations": "Filtrar estações",
  "common.filterStationSourceDescription": "Selecione os fornecedores de estação que deseja exibir no mapa",
  "common.findStationsNearYou": "Encontrar estações perto de si",
  "common.firmwareVersion": "Versão do firmware",
  "common.forecast": "Previsão",
  "common.forecastComparisonDescription": "Compare facilmente dados de diferentes modelos meteorológicos disponíveis",
  "common.forecastModelComparison": "Comparação de modelos meteorológicos",
  "common.forecastModelCoverage": "Cobertura",
  "common.forecastModelDescription": "Descrição",
  "common.forecastModelDescription_AROME": "Modelo de alta resolução com resolução de convecção da Météo France sobre a Europa Ocidental a 1,3 km. O melhor da categoria para previsões de curto prazo em França; atualizado a cada três horas.",
  "common.forecastModelDescription_ARPEGE_EU": "O ninho europeu do modelo ARPEGE da Météo France com resolução de 10 km. Previsões de médio prazo sobre a Europa, atualizadas quatro vezes por dia.",
  "common.forecastModelDescription_ARPEGE_GLOBAL": "Modelo global numérico de previsão meteorológica da Météo France com resolução de 25 km, até cerca de 4 dias. Atualizado quatro vezes por dia.",
  "common.forecastModelDescription_DMI_DINI": "HARMONIE DINI da DMI: um modelo que permite convecção sobre o noroeste da Europa — Dinamarca, Benelux, Irlanda, Reino Unido e Escandinávia — com resolução de 2 km até 60 horas, atualizado oito vezes por dia. Contém dados abertos da DMI modificados (CC BY 4.0).",
  "common.forecastModelDescription_EC_GDPS": "Sistema Global Determinístico de Previsão da Environment Canada: um modelo mundial de médio prazo com resolução de 15 km até 10 dias, atualizado duas vezes por dia.",
  "common.forecastModelDescription_EC_HRDPS": "Sistema Determinístico de Previsão de Alta Resolução da Environment Canada: um modelo que permite convecção sobre o Canadá e o norte dos Estados Unidos com resolução de 2,5 km até 48 horas, atualizado quatro vezes por dia.",
  "common.forecastModelDescription_EC_RDPS": "Sistema Regional Determinístico de Previsão da Environment Canada: um modelo de médio prazo sobre a América do Norte com resolução de 10 km, atualizado quatro vezes por dia.",
  "common.forecastModelDescription_ECMWF_HRES": "O modelo de alta resolução (IFS) do Centro Europeu de Previsões Meteorológicas a Médio Prazo, amplamente considerado o principal sistema de previsão global do mundo. Cobre todo o planeta com resolução de 25 km até 15 dias, atualizado quatro vezes por dia. Contém dados abertos do ECMWF modificados (CC BY 4.0).",
  "common.forecastModelDescription_GFS": "O modelo global emblemático de médio prazo da NOAA. Cobre todo o planeta com resolução de 25 km até 16 dias, atualizado quatro vezes por dia.",
  "common.forecastModelDescription_HRRR_CONUS": "O High-Resolution Rapid Refresh da NOAA: um modelo com resolução de convecção sobre os Estados Unidos continentais a 3 km de resolução, atualizado a cada hora. Mais adequado para previsões de muito curto prazo de trovoadas e tempo severo.",
  "common.forecastModelDescription_ICON": "O modelo global ICON do DWD com resolução de 13 km que cobre todo o planeta até 7,5 dias, atualizado quatro vezes por dia. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_2I": "ICON-2I da ItaliaMeteo, operado em conjunto com a ARPAE: um modelo que permite convecção sobre a Itália com resolução de 2,2 km até 72 horas, atualizado duas vezes por dia. Contém dados abertos da ItaliaMeteo (CC BY 4.0).",
  "common.forecastModelDescription_ICON_CH1": "A execução de controlo do ICON-CH1-EPS da MeteoSwiss: um modelo que permite convecção sobre os Alpes com resolução de 1 km até 33 horas, atualizado a cada três horas.",
  "common.forecastModelDescription_ICON_CH2": "A execução de controlo do ICON-CH2-EPS da MeteoSwiss: um modelo que permite convecção sobre os Alpes — Suíça e a região alpina circundante — com resolução de 2,1 km até 120 horas, atualizado quatro vezes por dia.",
  "common.forecastModelDescription_ICON_DE": "Modelo de alta resolução com resolução de convecção do DWD sobre a Alemanha e países vizinhos a 2,2 km de resolução. Previsões de curto prazo atualizadas duas vezes por dia. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_ICON_EU": "O ninho europeu do modelo ICON do DWD com resolução de 7 km cobrindo a Europa e o Atlântico Norte. Previsões de médio prazo atualizadas quatro vezes por dia. Datenbasis: Deutscher Wetterdienst.",
  "common.forecastModelDescription_MET_NORWAY": "O serviço aberto de previsão meteorológica do Instituto Meteorológico Norueguês, combinando modelos nórdicos de alta resolução com dados do ECMWF para fornecer previsões mundiais até 10 dias.",
  "common.forecastModelDescription_MF_AROME_ANTILLES": "Ninho AROME sobre as Antilhas francesas (Guadalupe, Martinica) com resolução de 2,5 km. Previsões de curto prazo atualizadas quatro vezes por dia.",
  "common.forecastModelDescription_MF_AROME_GUYANE": "Ninho AROME sobre a Guiana Francesa com resolução de 2,5 km. Previsões de curto prazo atualizadas quatro vezes por dia.",
  "common.forecastModelDescription_MF_AROME_NOUVELLE_CALEDONIE": "Ninho AROME sobre a Nova Caledónia com resolução de 2,5 km. Previsões de curto prazo atualizadas quatro vezes por dia.",
  "common.forecastModelDescription_MF_AROME_POLYNESIE": "Ninho AROME sobre a Polinésia Francesa com resolução de 2,5 km. Previsões de curto prazo atualizadas quatro vezes por dia.",
  "common.forecastModelDescription_MF_AROME_REUNION_MAYOTTE": "Ninho AROME sobre Reunião e Mayotte com resolução de 2,5 km. Previsões de curto prazo atualizadas quatro vezes por dia.",
  "common.forecastModelDescription_NAM_CONUS": "Ninho do modelo North American Mesoscale da NOAA sobre os Estados Unidos continentais com resolução de 5 km. Previsões de curto prazo atualizadas quatro vezes por dia.",
  "common.forecastModelDescription_NAM_NORTH_AMERICA": "Modelo North American Mesoscale da NOAA cobrindo toda a América do Norte com resolução de 32 km. Atualizado quatro vezes por dia.",
  "common.forecastModelDescription_SMARTMIXIN_MULTIMODEL": "A previsão emblemática da SmartMixin. Para cada hora na sua localização, escolhemos o melhor modelo disponível — normalmente um modelo regional de alta resolução onde existe um (AROME em França, ICON-D2 na Alemanha, HRRR nos Estados Unidos, ARPEGE Europe em todo o continente…) e recorremos a um modelo global noutros locais — preenchendo depois quaisquer lacunas a partir de fontes vizinhas. O resultado é uma única previsão contínua que cobre qualquer lugar do mundo até 14 dias, atualizada automaticamente sempre que algum dos modelos subjacentes é atualizado.",
  "common.forecastModelDescription_WEATHERFLOW_FORECAST": "Previsão global proprietária da Weatherflow que combina vários modelos numéricos de previsão meteorológica com observações da sua rede de estações meteorológicas Tempest. Horizonte mundial de 10 dias.",
  "common.forecastModelDetailTitle": "Modelo de previsão",
  "common.forecastModelScopeGlobal": "Global",
  "common.forecastModelScopeGlobalDescription": "Este modelo cobre todo o planeta.",
  "common.forecastModelScopeRegional": "Regional",
  "common.forecastModelScopeRegionalDescription": "Este modelo cobre apenas uma região específica.",
  "common.forecastModelSpecifications": "Especificações",
  "common.forecastSources": "Fontes de previsão",
  "common.freeAccount": "Conta gratuita",
  "common.freeSubscription": "subscrição gratuita",
  "common.freeTrialForPeriod": "Experimentação gratuita por {period} dias",
  "common.frequency": "Frequência",
  "common.full": "Completo",
  "common.fullscreen": "Ecrã inteiro",
  "common.getStartedFree": "Começar Grátis",
  "common.getUnlimitedAccess": "Acesso ilimitado a:",
  "common.good": "Bom",
  "common.hail": "Granizo",
  "common.help": "Ajuda",
  "common.helpCategoryAccount": "Conta",
  "common.helpCategoryBilling": "Faturação",
  "common.helpCategoryGettingStarted": "Primeiros passos",
  "common.helpCategoryProviders": "Fornecedores",
  "common.helpCategoryStations": "Estações",
  "common.helpCategoryTroubleshooting": "Solução de problemas",
  "common.helpCenter": "Central de ajuda",
  "common.helpCenterDescription": "Encontre respostas para perguntas comuns e aprenda a aproveitar ao máximo o SmartMixin.",
  "common.hg": "Proteção contra geada",
  "common.hidden": "Ocultos",
  "common.hiddenSensors": "Sensores ocultos",
  "common.hiddenStations": "Estações ocultas",
  "common.hiddenStationsDescription": "Pode voltar a mostrar uma estação tocando no ícone do olho ao lado dela.",
  "common.high": "Alto",
  "common.home": "Casa",
  "common.homeConnectService": "Possui uma estação meteorológica? Conecte o seu serviço",
  "common.homeInformation": "Informação sobre a casa",
  "common.homeIntroduction": "Comece a ligar as suas contas externas para tirar proveito das características do SmartMixin.",
  "common.homeName": "Nome da casa",
  "common.homeSubtitle": "O seu tempo, tudo num só lugar",
  "common.horizon": "Horizonte",
  "common.horizonValue": "até {value} horas",
  "common.iDontKnowYet": "Eu ainda não sei",
  "common.indoor": "Interior",
  "common.lastRainEvent": "último evento de chuva",
  "common.lastUpdate": "Última atualização",
  "common.legendHeavy": "Forte",
  "common.legendLight": "Leve",
  "common.legendLightningHelp": "A cor mostra a idade de cada raio nos últimos {minutes} minutos — os mais recentes em branco, os mais antigos em vermelho escuro.",
  "common.legendNewest": "Mais recentes",
  "common.legendOldest": "Mais antigos",
  "common.legendStationsHelp": "A cor do marcador reflete o valor da métrica selecionada.",
  "common.lightningDataAttribution": "Dados de raios: Blitzortung.org",
  "common.lightningStrikes": "Raios",
  "common.lightningStrikesDescription": "Mostrar raios em tempo real no mapa",
  "common.linkToSection": "Link para esta seção",
  "common.loading": "A carregar",
  "common.location": "Localização",
  "common.locationAddedToFavorites": "Localização adicionada aos favoritos",
  "common.locationNotGranted": "A permissão de localização não é concedida. Permita o acesso à sua localização nas configurações do dispositivo.",
  "common.locationRemovedFromFavorites": "Localização removida dos favoritos",
  "common.locations": "Localizações",
  "common.low": "Baixo",
  "common.manage": "Gerir",
  "common.manageAccount": "Gerir conta",
  "common.manageMySubscription": "Gerir a minha subscrição",
  "common.manageSensors": "Gerir sensores",
  "common.manageSensorsDescription": "Arraste itens para reordenar os sensores. Toque no ícone do olho para mostrar ou ocultar sensores. Toque num nome para o renomear.",
  "common.manualBoost": "Impulso manual",
  "common.manualSetpointUntil": "Ponto de ajuste manual até",
  "common.mapLayers": "Camadas do mapa",
  "common.mapLegend": "Legenda do mapa",
  "common.maxFavoriteLocationsReached": "Só pode ter até 5 locais favoritos. Remova um para adicionar outro.",
  "common.maximum": "Máximo",
  "common.measureToDisplay": "Medir para exibir",
  "common.medium": "Médio",
  "common.meshSize": "Tamanho da rede",
  "common.minimum": "Mínimo",
  "common.minRead": "{minutes} min de leitura",
  "common.modifyFavoriteStations": "Modificar estações favoritas",
  "common.modifyFavoriteStationsDescription": "Pode reordenar as suas estações favoritas arrastando-as. Também pode removê-las da lista.",
  "common.moduleType": "Tipo de módulo",
  "common.monthTotal": "Este mês",
  "common.more": "Mais",
  "common.moreInformation": "Mais informação",
  "common.myLocation": "Minha localização",
  "common.nearbyWeatherStations": "Estações meteorológicas próximas",
  "common.next": "Próximo",
  "common.nextHours": "Horas seguintes",
  "common.no": "Não",
  "common.noAccountNeeded": "Sem necessidade de conta",
  "common.noDataForThisPeriod": "Sem dados para este período",
  "common.noLocationsFound": "Nenhum local encontrado",
  "common.noNetatmoWeatherStationYet": "Ainda não tem uma estação meteorológica Netatmo.",
  "common.noOutdoorModule": "Não há módulo exterior funcional para esta estação.",
  "common.noSearchResults": "Nenhum artigo corresponde à sua pesquisa",
  "common.noStationsFound": "Nenhuma estação encontrada",
  "common.noThermostatYet": "Ainda não tem um termóstato.",
  "common.notNow": "Agora não",
  "common.notPurchasedYet": "Parece que isto ainda não foi comprado.",
  "common.noWeatherStation": "Sem estação meteorológica.",
  "common.noWeatherStationYet": "Ainda não tem uma estação meteorológica.",
  "common.numberOfActiveWarnings": "{warning_count} avisos meteorológicos ativos",
  "common.onThisPage": "Nesta página",
  "common.openSettings": "Abra as configurações",
  "common.orChooseMonthly": "Ou escolha mensal:",
  "common.outdatedModule": "A informação sobre este módulo está desatualizada.",
  "common.outdoor": "Exterior",
  "common.outdoorTemperature": "Temperatura exterior",
  "common.pageNotFound": "Página Não Encontrada",
  "common.pageNotFoundDescription": "A página que procura não existe ou foi movida.",
  "common.passwordUpdated": "Palavra-passe atualizada com sucesso.",
  "common.personalWeatherIntelligence": "Sua Inteligência Meteorológica Pessoal",
  "common.platformMobileApp": "Aplicação móvel",
  "common.platformMobileOnly": "Apenas na aplicação móvel",
  "common.platformWebApp": "Aplicação web",
  "common.platformWebOnly": "Apenas na aplicação web",
  "common.popularArticles": "Artigos populares",
  "common.premiumAccount": "Conta premium",
  "common.premiumDescription": "A subscrição Premium desbloqueia uma vasta variedade de características adicionais tais como análises meteorológicas avançadas, modelos de previsão regional e muito mais.",
  "common.premiumFeatureAlerts": "Alertas Meteorológicos",
  "common.premiumFeatureAnalysis": "Análise Meteorológica Avançada",
  "common.premiumFeatureCharts": "Comparações de Gráficos",
  "common.premiumFeatureExport": "Exportação de Dados",
  "common.premiumFeatureForecast": "Modelos de Previsão Regional",
  "common.premiumFeatureNotification": "Widget da Barra de Status",
  "common.premiumFeatureTitle": "Recurso Premium",
  "common.premiumFeatureWidgets": "Widgets do ecrã inicial",
  "common.pressureSummary": "Síntese de pressão",
  "common.previous": "Anterior",
  "common.previousHours": "Horas anteriores",
  "common.profileUpdated": "Perfil atualizado com sucesso.",
  "common.purchasedNetatmoPro": "Comprou anteriormente o Netatmo Pro ({date}). Subscreva uma das ofertas abaixo para ter acesso a todos os recursos premium da aplicação.",
  "common.radarDataAttribution": "Dados de radar: NOAA / EUMETNET OPERA via LibreWXR",
  "common.rain": "Chuva",
  "common.rainEvents": "Eventos de chuva",
  "common.rainfallMeasurement": "Medição da precipitação",
  "common.rainRadar": "Radar de chuva",
  "common.rainRadarDescription": "Exibir sobreposição de radar de chuva no mapa",
  "common.rainSummary": "Resumo da precipitação",
  "common.range": "Amplitude",
  "common.recentLocations": "Recente",
  "common.recentLocationsEmpty": "O seu histórico recente está vazio.",
  "common.recentStations": "Estações recentes",
  "common.relatedArticles": "Artigos relacionados",
  "common.relay": "Retransmissão",
  "common.removeFromFavorites": "Remover dos favoritos",
  "common.renameSensors": "Renomear sensores",
  "common.resetZoom": "Redefinir o zoom",
  "common.restorePurchase": "Restaurar compra",
  "common.room": "Quarto",
  "common.rooms": "Quartos",
  "common.savingsPercent": "Poupe {percent}%",
  "common.searchArticles": "Pesquisar artigos...",
  "common.searchForALocation": "Pesquisar uma localização...",
  "common.searchForLocation": "Procurar uma localização",
  "common.searchForWeatherStation": "Procurar uma estação meteorológica",
  "common.searchResults": "Resultados da pesquisa",
  "common.searchResultsEmpty": "Nenhum resultado encontrado.",
  "common.searchResultsFound": "{count, plural, one {# resultado encontrado} other {# resultados encontrados}}",
  "common.searchStationsDescription": "Digite uma cidade, endereço ou nome de local para encontrar estações meteorológicas próximas.",
  "common.searchStationsHint": "Use a barra de pesquisa acima para descobrir estações meteorológicas em qualquer lugar do mundo.",
  "common.selectStationForComparison": "Selecione a estação para comparação",
  "common.selectWeatherForecastProvider": "Por favor escolha um fornecedor meteorológico",
  "common.serialNumber": "Número de série",
  "common.share": "Partilhar",
  "common.shareOutdoorMeasures": "Partilhe as suas medições exteriores",
  "common.shareOutdoorMeasuresDescription": "Participe na comunidade SmartMixin tornando as suas medições visíveis para os outros. As medições interiores nunca serão partilhadas.",
  "common.shareYourWeather": "Partilhe o seu tempo",
  "common.signalStrength": "Força do sinal",
  "common.skip": "Saltar",
  "common.smartThermostat": "Termóstato inteligente",
  "common.smartValve": "Válvula inteligente",
  "common.snow": "Neve",
  "common.start": "Começar",
  "common.startFreeTrial": "Iniciar Teste Gratuito",
  "common.startTime": "Começo",
  "common.station": "estação",
  "common.stationAddedToFavorites": "Estação adicionada aos favoritos",
  "common.stationComparison": "Comparação de estação",
  "common.stationComparisonDescription": "Permite comparar dados meteorológicos históricos com os de outra estação.",
  "common.stationInformation": "Informação da estação",
  "common.stationName": "Nome da estação",
  "common.stationObservationsDescription": "Exibir as últimas observações das estações meteorológicas",
  "common.stationRemovedFromFavorites": "Estação removida dos favoritos",
  "common.stations": "estações",
  "common.stationsNear": "Estações perto de",
  "common.stationType": "Tipo de estação",
  "common.statusOffline": "Offline",
  "common.statusOnline": "Online",
  "common.statusStale": "Desatualizado",
  "common.statusSyncing": "A sincronizar",
  "common.stillNeedHelp": "Ainda precisa de ajuda?",
  "common.stillNeedHelpDescription": "Se este artigo não respondeu à sua pergunta, terei prazer em ajudá-lo diretamente.",
  "common.subscribeNow": "Subscrever agora - sem teste",
  "common.sumOverThePeriod": "Acumulado ao longo do período",
  "common.switchToPremium": "Mudar para SmartMixin Premium",
  "common.temperatureShort": "Temp.",
  "common.temperatureSummary": "Resumo da temperatura",
  "common.thankYouForFeedback": "Obrigado pelo seu feedback!",
  "common.thenPrice": "depois {price}",
  "common.timeSelection": "Seleção de tempo",
  "common.timezone": "Fuso horário",
  "common.totalDuration": "Duração total",
  "common.tryAnotherLocation": "Não encontramos estações meteorológicas perto desta localização. Tente pesquisar noutra área.",
  "common.unknown": "Desconhecido",
  "common.untilChanged": "Até mudar",
  "common.untilTime": "Até {time}",
  "common.updateAvailable": "Atualização disponível",
  "common.updateAvailableOpenAppStore": "Toque para abrir a App Store",
  "common.updateAvailableOpenGooglePlay": "Toque para abrir o Google Play",
  "common.updateAvailableVersion": "Atualização disponível: v{version}",
  "common.upgrade": "Atualização",
  "common.upgradeRequiredAndroid": "Uma atualização da sua aplicação é requerida, vá para o Google Play para atualizar.",
  "common.upgradeRequiredIos": "Uma atualização da sua aplicação é requerida, vá para a loja de aplicações para atualizar.",
  "common.validate": "Validar",
  "common.validEmail": "Um endereço de email válido é requerido.",
  "common.very_low": "Muito baixo",
  "common.visitNetatmoWebsite": "Visitar o website Netatmo",
  "common.wasArticleHelpful": "Este artigo foi útil?",
  "common.weatherCondition": "Condição climática",
  "common.weatherflowNCRain": "NC Rain (Nearcast Rain)",
  "common.weatherflowNCRainDescription": "NC Rain é uma fonte de dados adicional fornecida através do Tempest Weather System, alimentado pela tecnologia Nearcast. Os dados da chuva NC são uma estimativa do acúmulo médio de chuva em torno de sua tempestade no nível do bairro",
  "common.weatherForecastModels": "Modelos de previsão do tempo",
  "common.weatherIntelligencePlatform": "A Plataforma de Inteligência Meteorológica",
  "common.weatherMap": "Mapa meteorológico",
  "common.weatherMapMetaDescription": "SmartMixin oferece mapas meteorológicos e de radar interativos para condições climáticas em todo o mundo.",
  "common.weatherObservations": "Observações meteorológicas",
  "common.weatherStation": "Estação meteorológica",
  "common.weatherStations": "Estações meteorológicas",
  "common.welcome": "Bem-vindo à SmartMixin!",
  "common.whenBackHome": "Quando irá voltar a casa?",
  "common.wifiStrength": "Força de sinal WiFi",
  "common.wind": "Vento",
  "common.windMeasurement": "Medição do vento",
  "common.windSpeed": "Velocidade do vento",
  "common.windSummary": "Síntese do vento",
  "common.yearToDate": "Este ano",
  "common.yes": "Sim",
  "common.zoomImage": "Ampliar imagem",
  "forecastMaps.addColor": "Adicionar cor",
  "forecastMaps.addLayer": "Adicionar camada",
  "forecastMaps.autoPreview": "Auto",
  "forecastMaps.backToMaps": "Voltar aos mapas",
  "forecastMaps.browseMaps": "Explorar mapas",
  "forecastMaps.build": "Gerar",
  "forecastMaps.buildCompleted": "Geração concluída",
  "forecastMaps.builderMetaDescription": "Componha mapas de previsão personalizados a partir das camadas dos modelos meteorológicos.",
  "forecastMaps.builderTitle": "Criador de mapas",
  "forecastMaps.buildFailed": "A geração falhou. Tente novamente.",
  "forecastMaps.buildNotPossible": "Este mapa ainda não pode ser gerado — não há dados de previsão disponíveis.",
  "forecastMaps.buildProgress": "A renderizar… {completed}/{total} passos",
  "forecastMaps.buildStarting": "A iniciar a geração…",
  "forecastMaps.byModel": "Por modelo",
  "forecastMaps.byZone": "Por zona",
  "forecastMaps.colormap": "Paleta de cores",
  "forecastMaps.colormapCustom": "Cores personalizadas",
  "forecastMaps.colormapGroupDomain": "Paletas meteorológicas",
  "forecastMaps.colormapGroupMatplotlib": "Paletas científicas",
  "forecastMaps.colorScale": "Escala de cores",
  "forecastMaps.comingSoon": "Esta vista estará disponível em breve.",
  "forecastMaps.contourLevels": "Níveis de contorno",
  "forecastMaps.countryCanada": "Canadá",
  "forecastMaps.countryFrance": "França",
  "forecastMaps.countryGermany": "Alemanha",
  "forecastMaps.countryItaly": "Itália",
  "forecastMaps.countryScandinavia": "Escandinávia",
  "forecastMaps.countrySpain": "Espanha",
  "forecastMaps.countrySwitzerland": "Suíça",
  "forecastMaps.countryUnitedStates": "Estados Unidos",
  "forecastMaps.customColormapMinColors": "Uma paleta personalizada precisa de pelo menos duas cores",
  "forecastMaps.customExtent": "Extensão personalizada",
  "forecastMaps.deleteMap": "Apagar mapa",
  "forecastMaps.deleteMapBody": "«{name}» e as suas renderizações serão apagados permanentemente.",
  "forecastMaps.deleteMapTitle": "Apagar este mapa?",
  "forecastMaps.displayName": "Nome de exibição",
  "forecastMaps.downloadMp4": "Transferir MP4",
  "forecastMaps.downscaling": "Fator de espaçamento das barbelas",
  "forecastMaps.dpi": "DPI",
  "forecastMaps.drawArea": "Desenhar área",
  "forecastMaps.east": "Este",
  "forecastMaps.editMap": "Editar mapa",
  "forecastMaps.exportBuilding": "A preparar o vídeo…",
  "forecastMaps.exportError": "A exportação do vídeo falhou. Tente novamente.",
  "forecastMaps.exportMp4": "Exportar MP4",
  "forecastMaps.exportNotReady": "O vídeo ainda não está pronto. Tente novamente mais tarde.",
  "forecastMaps.extentDrawHint": "Arraste no mapa para desenhar a área",
  "forecastMaps.extentInvalid": "O oeste deve ser menor que o este e o sul menor que o norte",
  "forecastMaps.extentPanZoomHint": "Desloque e amplie até a área preencher o enquadramento",
  "forecastMaps.flipbookView": "Animação",
  "forecastMaps.forecastModel": "Modelo de previsão",
  "forecastMaps.forkAndEdit": "Duplicar e editar",
  "forecastMaps.height": "Altura (polegadas)",
  "forecastMaps.hourOffset": "+{hour} h",
  "forecastMaps.invalidHexColor": "Cor inválida — use #RRGGBB",
  "forecastMaps.layers": "Camadas",
  "forecastMaps.layerTypeBarbs": "Barbelas de vento",
  "forecastMaps.layerTypeContour": "Linhas de contorno",
  "forecastMaps.layerTypeFilledContour": "Contornos preenchidos",
  "forecastMaps.layerTypeMagnitude": "Magnitude",
  "forecastMaps.layerTypeRaster": "Raster",
  "forecastMaps.layerTypeVectorField": "Campo vetorial",
  "forecastMaps.leave": "Sair",
  "forecastMaps.levelsCount": "Quantidade",
  "forecastMaps.levelsInvalid": "Níveis de contorno inválidos",
  "forecastMaps.levelsModeArange": "Passo fixo",
  "forecastMaps.levelsModeExplicit": "Valores explícitos",
  "forecastMaps.levelsModeLinspace": "Espaçamento uniforme (quantidade)",
  "forecastMaps.levelsStep": "Passo",
  "forecastMaps.levelsValues": "Valores",
  "forecastMaps.levelsValuesHint": "Separados por vírgulas, ascendentes",
  "forecastMaps.localTimeHint": "Apresentado na sua hora local",
  "forecastMaps.map": "Mapa",
  "forecastMaps.mapDescription": "Descrição",
  "forecastMaps.mapName": "Nome do mapa",
  "forecastMaps.mapNameRequired": "Introduza um nome",
  "forecastMaps.mapSettings": "Definições do mapa",
  "forecastMaps.mapView": "Mapa interativo",
  "forecastMaps.maxLayersReached": "Este mapa atingiu o máximo de {max} camadas.",
  "forecastMaps.maxValue": "Valor máximo",
  "forecastMaps.memoryBudgetExceeded": "A resolução excede o orçamento de renderização — reduza o DPI ou a altura",
  "forecastMaps.memoryBudgetUsage": "Orçamento de renderização: {percent}%",
  "forecastMaps.metaDescription": "Mapas de previsão animados gerados a partir dos modelos meteorológicos.",
  "forecastMaps.metric": "Medida",
  "forecastMaps.metricRequired": "Selecione uma medida",
  "forecastMaps.metricUnavailable": "Indisponível para este modelo",
  "forecastMaps.minBelowMax": "O mínimo deve ser menor que o máximo",
  "forecastMaps.minMaxRequired": "Os valores mínimo e máximo são obrigatórios para este tipo de camada",
  "forecastMaps.minValue": "Valor mínimo",
  "forecastMaps.modelNoRun": "Ainda não há nenhuma execução concluída",
  "forecastMaps.moveLayerDown": "Mover para baixo",
  "forecastMaps.moveLayerUp": "Mover para cima",
  "forecastMaps.myMaps": "Os meus mapas",
  "forecastMaps.nanClipToMin": "Limitar ao mínimo",
  "forecastMaps.nanMask": "Mascarar",
  "forecastMaps.nanPolicy": "Dados em falta",
  "forecastMaps.nanSkip": "Ignorar",
  "forecastMaps.newMap": "Novo mapa",
  "forecastMaps.noCompletedRun": "Este mapa ainda não foi gerado. Volte a verificar em breve.",
  "forecastMaps.noLayers": "Ainda não há camadas. Adicione uma camada para começar.",
  "forecastMaps.noMapsAvailable": "Ainda não há mapas de previsão disponíveis.",
  "forecastMaps.north": "Norte",
  "forecastMaps.opacity": "Opacidade",
  "forecastMaps.overlayLegend": "Legenda",
  "forecastMaps.pause": "Pausa",
  "forecastMaps.play": "Reproduzir",
  "forecastMaps.pointValueError": "Não foi possível carregar a previsão para este ponto.",
  "forecastMaps.pointValueLoading": "A carregar a previsão…",
  "forecastMaps.pointValueUnavailable": "Sem dados para esta hora.",
  "forecastMaps.presets": "Predefinições",
  "forecastMaps.preview": "Pré-visualização",
  "forecastMaps.previewEmptyHint": "Configure pelo menos uma camada válida para renderizar uma pré-visualização.",
  "forecastMaps.previewFailed": "A pré-visualização falhou",
  "forecastMaps.previewHour": "Hora de previsão",
  "forecastMaps.previewRendering": "A renderizar a pré-visualização…",
  "forecastMaps.projection": "Projeção",
  "forecastMaps.projectionLambertConformal": "Lambert conforme",
  "forecastMaps.projectionMercator": "Mercator",
  "forecastMaps.projectionPlateCarree": "Plate carrée",
  "forecastMaps.projectionStereographic": "Estereográfica",
  "forecastMaps.regionEurope": "Europa",
  "forecastMaps.regionNorthAmerica": "América do Norte",
  "forecastMaps.removeColor": "Remover cor",
  "forecastMaps.removeLayer": "Remover camada",
  "forecastMaps.retry": "Tentar novamente",
  "forecastMaps.run": "Execução: {run}",
  "forecastMaps.save": "Guardar",
  "forecastMaps.selectExtentOnMap": "Selecionar área no mapa",
  "forecastMaps.south": "Sul",
  "forecastMaps.title": "Mapas de previsão",
  "forecastMaps.uMetric": "Componente U",
  "forecastMaps.unitConversion": "Conversão de unidades",
  "forecastMaps.unitNone": "Nenhuma",
  "forecastMaps.unsavedChangesBody": "Tem alterações não guardadas. Sair e descartá-las?",
  "forecastMaps.unsavedChangesTitle": "Alterações não guardadas",
  "forecastMaps.useCurrentView": "Usar vista atual",
  "forecastMaps.useModelDomain": "Desativado: é usado o domínio completo do modelo",
  "forecastMaps.utcTime": "UTC: {time}",
  "forecastMaps.uvMetricsDiffer": "As medidas U e V devem ser diferentes",
  "forecastMaps.validTime": "Válido: {time}",
  "forecastMaps.valueBetween": "Deve estar entre {min} e {max}",
  "forecastMaps.variable": "Variável",
  "forecastMaps.viewMap": "Ver mapa",
  "forecastMaps.vMetric": "Componente V",
  "forecastMaps.west": "Oeste",
  "forecastMaps.windAnimation": "Animação do vento",
  "intro.locationDescription": "Ative o acesso à localização para obter previsões precisas adaptadas à sua área exata — nada de previsões genéricas.",
  "intro.locationTitle": "Previsões feitas para si",
  "intro.notificationDescription": "Ative as notificações para receber alertas oportunos sobre mudanças climáticas que importam para si — chuva, neve ou condições severas, exatamente quando precisa de saber.",
  "intro.notificationsTitle": "Nunca perca uma mudança no tempo",
  "intro.readyDescription": "Desfrute de previsões precisas, informações meteorológicas em tempo real e dados das estações do mundo todo — tudo numa aplicação poderosa.",
  "intro.readyTitle": "Está tudo pronto!",
  "intro.welcomeDescription": "Obtenha previsões hiperlocais fornecidas pelas melhores agências meteorológicas — além de acesso a mais de 40.000 estações meteorológicas em todo o mundo para ver as condições reais, passadas e presentes.",
  "intro.welcomeTitle": "O seu tempo, reinventado",
  "landing.alerts": "Alertas",
  "landing.alertsDescription": "Crie seus próprios alertas e seja notificado assim que forem acionados.",
  "landing.featureAlertsDescription": "Defina alertas personalizados para condições que lhe interessam—temperatura, vento, chuva e mais.",
  "landing.featureAlertsTitle": "Alertas inteligentes",
  "landing.featureAnalyticsDescription": "Mergulhe nos seus dados com gráficos interativos, comparações lado a lado e análise de tendências que vão além das métricas básicas.",
  "landing.featureAnalyticsTitle": "Análise poderosa",
  "landing.featureExportDescription": "Descarregue os seus dados em formato CSV para análise em Excel, integração com outros sistemas ou cópia de segurança.",
  "landing.featureExportTitle": "Exportar em qualquer lugar",
  "landing.featureForecastDescription": "Compare previsões de mais de 10 modelos meteorológicos incluindo GFS, ECMWF, ICON e outros para ver qual funciona melhor na sua localização.",
  "landing.featureForecastTitle": "Comparação de previsões",
  "landing.featureHistoryDescription": "Aceda a dados históricos com escala horária, diária e mensal. Exporte para CSV para investigação ou arquivos pessoais.",
  "landing.featureHistoryTitle": "Histórico detalhado",
  "landing.featureMultiBrandDescription": "Ligue estações de Netatmo, Ecowitt, Ambient Weather, Davis, WeatherFlow e mais—tudo num único painel.",
  "landing.featureMultiBrandTitle": "Suporte multi-marca",
  "landing.featuresSubtitle": "Concebido para entusiastas de meteorologia que exigem mais do que uma app básica de estação meteorológica.",
  "landing.featuresTitle": "Tudo o que precisa para analisar o tempo",
  "landing.finalCtaButton": "Criar conta gratuita",
  "landing.finalCtaSubtitle": "Junte-se a milhares de entusiastas de meteorologia que confiam no SmartMixin para os seus dados meteorológicos.",
  "landing.finalCtaTitle": "Pronto para melhorar a sua experiência meteorológica?",
  "landing.forecastDescription": "Aceda a alguns dos melhores modelos de previsão do tempo e compare-os para ter uma ideia de como estará o tempo.",
  "landing.forecasts": "Previsões",
  "landing.heroCta": "Começar gratuitamente",
  "landing.heroDescription": "Combine várias estações meteorológicas de qualquer marca, compare modelos de previsão e analise os seus dados com gráficos e exportações detalhadas.",
  "landing.heroSecondaryCta": "Ver funcionalidades",
  "landing.heroTagline": "Para entusiastas do tempo",
  "landing.heroTitle": "Todos os dados meteorológicos. Uma plataforma.",
  "landing.pricingFeatureAdvancedMetrics": "Métricas avançadas",
  "landing.pricingFeatureAlerts": "Alertas personalizados",
  "landing.pricingFeatureExport": "Exportação de dados (CSV)",
  "landing.pricingFeatureForecastComparison": "Comparação de previsões",
  "landing.pricingFeatureForecasts": "Modelos de previsão",
  "landing.pricingFeatureForecastsFreeTier": "1 modelo",
  "landing.pricingFeatureForecastsPremiumTier": "Todos os modelos (10+)",
  "landing.pricingFeatureReports": "Análises e relatórios",
  "landing.pricingFeatureStationComparison": "Comparação de estações",
  "landing.pricingFeatureWidgets": "Widgets do ecrã inicial",
  "landing.pricingFeatureYearOverYear": "Análise ano a ano",
  "landing.pricingFree": "Gratuito",
  "landing.pricingFreeCta": "Começar",
  "landing.pricingFreePrice": "0 €",
  "landing.pricingMostPopular": "Mais popular",
  "landing.pricingPremium": "Premium",
  "landing.pricingPremiumCta": "Começar",
  "landing.pricingPremiumDescription": "A partir de 1,99 €/mês — subscreva na web, App Store ou Google Play",
  "landing.pricingSubtitle": "Comece gratuitamente, atualize quando precisar de mais.",
  "landing.pricingTitle": "Preços simples e transparentes",
  "landing.smartMixinDescription": "SmartMixin é uma aplicação que fornece acesso à sua estação meteorológica e a mais de 40 mil outras estações em todo o mundo. Ajuda-o a ver e compreender os dados meteorológicos.",
  "landing.statBrands": "Marcas suportadas",
  "landing.statForecasts": "Modelos de previsão",
  "landing.statStations": "Estações ligadas",
  "landing.supportedDevices": "Dispositivos suportados",
  "landing.supportedDevicesDescription": "Além das estações da Organização Meteorológica Mundial, a SmartMixin apoia um número crescente de marcas de estações meteorológicas.",
  "landing.supportedDevicesNote": "Além de mais de 40.000 estações públicas da Organização Meteorológica Mundial",
  "landing.supportedDevicesSubtitle": "Ligue estações meteorológicas de marcas líderes e veja todos os dados num só lugar.",
  "landing.supportedDevicesTitle": "Funciona com as suas estações",
  "landing.thermostatDescription": "Conecte o seu termóstato Netatmo para correlacionar padrões de aquecimento com condições externas.",
  "landing.thermostatManufacturers": "Os fabricantes de termóstatos também têm suporte para correlacionar o aquecimento com as condições externas.",
  "landing.thermostatTitle": "Integração com casa inteligente",
  "landing.weatherAnalysis": "Análise Meteorológica",
  "landing.weatherAnalysisDescription": "SmartMixin vem com muita visualização de dados que permite analisar dados meteorológicos.",
  "landing.weatherAssistant": "Seu assistente meteorológico",
  "landing.weatherAssistantDescription": "Quer esteja interessado em condições climáticas atuais, históricas ou previstas, o SmartMixin fornece vários insights sempre que precisar deles.",
  "landing.weatherForecastModels": "Modelos de previsão do tempo",
  "landing.weatherForecastModelsDescription": "SmartMixin fornece acesso aos modelos de previsão do tempo mais precisos. Pode facilmente comparar as suas previsões e ter a sua própria ideia.",
  "landing.weatherMap": "Mapa meteorológico",
  "landing.weatherMapDescription": "Navegue no mapa e visualize como está o clima em qualquer lugar do mundo.",
  "network.cancelError": "O pedido foi cancelado",
  "network.connectionError": "Servidor não disponível",
  "network.networkError": "Rede não disponível",
  "network.serverError": "Algo correu errado…",
  "network.timeoutError": "Tempo limite de conexão",
  "network.unknownError": "Erro desconhecido",
  "providerHints.ambientWeatherApiKey": "Criada nas definições da sua conta ambientweather.net.",
  "providerHints.davisApiSecret": "Mostrado apenas uma vez ao criar a chave API V2 — guarde-o em segurança.",
  "providerHints.davisV2ApiKey": "Da página de chaves API V2 em weatherlink.com.",
  "providerHints.ecowittApi": "Da página API da sua conta Ecowitt.",
  "providerHints.ecowittApp": "A chave de aplicação, também da sua conta Ecowitt.",
  "providerHints.myAcuriteCredentialsBanner": "Use o e-mail e a palavra-passe da sua conta My AcuRite — não o acesso SmartMixin.",
  "providerHints.myAcuriteEmail": "O e-mail da sua conta My AcuRite — não o seu acesso SmartMixin.",
  "providerHints.myAcuritePassword": "A palavra-passe da sua conta My AcuRite.",
  "providerHints.weatherflowToken": "Token de uso pessoal de tempestwx.com → definições → autorizações de dados.",
  "providerHints.wundergroundEditKey": "Usar outra chave",
  "providerHints.wundergroundKey": "Uma sequência longa da página de chaves API da sua conta Weather Underground — não a sua palavra-passe do wunderground.com.",
  "providerHints.wundergroundKeyExample": "ex. 5f6a7b8c9dabcdef…",
  "providerHints.wundergroundKeyVerified": "Chave API verificada",
  "providerHints.wundergroundKeyVerifying": "A verificar chave…",
  "providerHints.wundergroundNoStationsNearby": "Não foram encontradas estações perto desta localização. Tente introduzir um ID de estação diretamente.",
  "providerHints.wundergroundStationId": "Qualquer ID de estação Weather Underground — a sua ou uma estação pública próxima.",
  "providerHints.wundergroundStationIdExample": "ex. KCASANFR123",
  "providerIntro.ambientWeatherStep2": "Obtenha a sua chave API Ambient Weather.",
  "providerIntro.davisStep2": "Obtenha a sua chave API V2 e segredo API Davis.",
  "providerIntro.ecowittStep2": "Obtenha a sua chave API e chave de aplicação Ecowitt.",
  "providerIntro.getStarted": "Começar",
  "providerIntro.myAcuriteStep2": "Use o e-mail e palavra-passe da sua conta My AcuRite existente.",
  "providerIntro.netatmoEnergyStep2": "Inicie sessão no Netatmo quando solicitado — não é necessária chave API.",
  "providerIntro.netatmoWeatherStep2": "Inicie sessão no Netatmo quando solicitado — não é necessária chave API.",
  "providerIntro.signupBanner": "Quase — crie a sua conta gratuita SmartMixin para ligar {provider}.",
  "providerIntro.step1": "Inicie sessão na sua conta SmartMixin (NÃO o login {provider}).",
  "providerIntro.step3EmailPassword": "Introduza-os aqui.",
  "providerIntro.step3KeyOrToken": "Cole aqui.",
  "providerIntro.step3OAuth": "Autorize SmartMixin na janela que aparece.",
  "providerIntro.step3Wunderground": "Cole a sua chave API e depois selecione uma estação próxima ou insira qualquer ID de estação.",
  "providerIntro.title": "Ligar {provider}",
  "providerIntro.weatherflowStep2": "Obtenha o seu token Tempest de uso pessoal.",
  "providerIntro.wundergroundBrowsePublic": "Não tem estação? Explore as públicas",
  "providerIntro.wundergroundFindNearby": "Encontrar estações próximas",
  "providerIntro.wundergroundOrEnterId": "Ou introduzir um ID de estação",
  "providerIntro.wundergroundStep2": "Obtenha a sua chave API Weather Underground. Depois poderá ligar qualquer estação — a sua ou uma pública.",
  "reports.agroMeteorology": "Agrometeorologia",
  "reports.analysis": "Análise",
  "reports.annualCumulativeRainfallComparison": "Comparação dos totais anuais de precipitação",
  "reports.annualHeatingDurationComparison": "Comparação da duração de aquecimento anual",
  "reports.annualHeatingEfficiency": "Eficiência térmica anual",
  "reports.annualIndoorComparison": "Comparação interior anual",
  "reports.annualIndoorReport": "Reporte interior anual",
  "reports.annualOutdoorComparison": "Comparação exterior anual",
  "reports.annualOutdoorReport": "Reporte exterior anual",
  "reports.annualReport": "Reporte anual",
  "reports.annualSolarReport": "Relatório solar anual",
  "reports.annualWaterBalance": "Balanço hídrico anual",
  "reports.annualWaterBalanceCarryOver": "Transferir do ano anterior",
  "reports.annualWaterBalanceDescription": "Um balanço hídrico (versão simplificada, apenas a chuva e a evapotranspiração são usadas) permite gerir o recurso hídrico",
  "reports.avgHumidity": "Humidade média",
  "reports.avgMaxTemperature": "T°max média",
  "reports.avgMetric": "Média – {metric}",
  "reports.avgMinTemperature": "T°min média",
  "reports.avgPressure": "Pressão atmosférica média",
  "reports.avgTemperature": "Temperatura média",
  "reports.climateNormalPeriodOfRecord": "Período de observação ({years, plural, one {# ano} other {# anos}})",
  "reports.climateNormals": "Normais climatológicas",
  "reports.climateNormalStandardLabel": "Normal padrão ({period})",
  "reports.climateTrendPerDecade": "Tendência da temperatura: {value} por década ao longo de {years, plural, one {# ano} other {# anos}}",
  "reports.coldestMonthRanking": "{month} mais frio já registado",
  "reports.comfortable": "Confortável (45% {lessThan} Humidity ≤ 60%)",
  "reports.cumulativeRainfall": "Precipitação acumulada",
  "reports.cumulativeRainfallDescription": "Acompanhe a precipitação total acumulada durante o período selecionado.",
  "reports.dailyMaxRainfall": "Precipitação máxima diária",
  "reports.dataExport": "Exportar dados",
  "reports.dataExportXlsxFormatDescription": "Exporte todos os dados da sua estação em formato Excel (*.xlsx). Após clicar no botão, irá receber um email com os seus dados processados após alguns minutos.",
  "reports.daysWithFrost": "Dias com geada",
  "reports.daysWithHeavyRain": "Dias de chuva forte (≥ {threshold})",
  "reports.daysWithoutThaw": "Dias sem degelo",
  "reports.daysWithStrongFrost": "Dias com geada forte",
  "reports.emailSent": "Um email foi enviado para a sua caixa de correio",
  "reports.frostDays": "Dias de geada",
  "reports.grasslandTemperatureSum": "Soma da temperatura da pastagem",
  "reports.grasslandTemperatureSumDescription": "Se a soma de {threshold} é excedida na primavera, foi alcançada a recuperação sustentável da vegetação (funciona na Europa)",
  "reports.growingDegreeDays": "Graus-dia de crescimento",
  "reports.highPressure": "Anticiclone (Pressão Média ≥ 1013mbar)",
  "reports.iceDays": "Dias de gelo",
  "reports.indoorReport": "Reporte interior",
  "reports.keyFacts": "Factos chave",
  "reports.longestDrySpell": "Maior período seco",
  "reports.longestRunOfRainyDays": "Número de dias chuvosos consecutivos",
  "reports.longestRunWithoutRun": "Número de dias consecutivos sem chuva",
  "reports.longestWetSpell": "Maior período chuvoso",
  "reports.lowPressure": "Baixa Pressão (Pressão Média {lessThan} 1013 mbar)",
  "reports.maxHumidity": "Humidade máxima",
  "reports.maxMetric": "Máximo – {metric}",
  "reports.maxPressure": "Pressão Atmosférica máxima",
  "reports.maxPressureMagnitude24h": "Amplitude Máxima (/24H)",
  "reports.maxTemperature": "Temperatura Máxima",
  "reports.maxTempGreaterThan": "T°max ≥",
  "reports.maxTempMagnitude24h": "Amplitude Máxima (/24H)",
  "reports.minHumidity": "Humidade mínima",
  "reports.minMetric": "Mínimo – {metric}",
  "reports.minPressure": "Pressão Atmosférica mínima",
  "reports.minPressureMagnitude24h": "Amplitude Mínima (/24H)",
  "reports.minTemperature": "Temperatura mínima",
  "reports.minTempMagnitude24h": "Amplitude Mínima (/24H)",
  "reports.monthlyHeatingEfficiency": "Eficiência térmica mensal",
  "reports.monthlyIndoorReport": "Reporte interior mensal",
  "reports.monthlyOutdoorReport": "Reporte exterior mensal",
  "reports.monthlyReport": "Reporte mensal",
  "reports.monthlySolarReport": "Relatório solar mensal",
  "reports.monthlyWindReport": "Reporte de vento mensal",
  "reports.numberOfDays": "Número de Dias",
  "reports.onThisDayInHistory": "Neste dia na história",
  "reports.outdoorReport": "Reporte exterior",
  "reports.rainfall": "Precipitação",
  "reports.rainyDays": "Dias chuvosos",
  "reports.recordDailyRain": "Dia mais chuvoso",
  "reports.recordHigh": "Recorde de calor",
  "reports.recordLow": "Recorde de frio",
  "reports.recordsAndClimatology": "Recordes e clima",
  "reports.recordsSince": "Recordes desde {date}",
  "reports.recordWindGust": "Rajada de vento mais forte",
  "reports.relativelyWet": "Relativamente húmido (60% {lessThan} Humidade ≤ 80 %)",
  "reports.sendEmail": "Enviar email",
  "reports.summerDays": "Dias de verão",
  "reports.tooDry": "Muito seco (Humidade ≤ 45%)",
  "reports.tooWet": "Muito húmido (Humidade {greaterThan} 80%)",
  "reports.tropicalNights": "Noites tropicais",
  "reports.warmestMonthRanking": "{month} mais quente já registado",
  "reports.waterBalance": "Balanço hídrico",
  "reports.yearsOfData": "{years, plural, one {# ano} other {# anos}} de dados",
  "reports.yearToDateTemperature": "Temperatura acumulada no ano",
  "reports.yearToDateTemperatureComparison": "Comparação de temperatura acumulada no ano",
  "sensors.aqiByChannel": "AQI por canal",
  "sensors.bgtSensors": "Globo negro e WBGT",
  "sensors.cameraFeed": "Câmara",
  "sensors.compareAqi": "Comparar AQI",
  "sensors.compareHumidity": "Comparar humidade",
  "sensors.compareMoisture": "Comparar humidade do solo",
  "sensors.comparePm25": "Comparar PM2.5",
  "sensors.compareTemperatures": "Comparar temperaturas",
  "sensors.depthByChannel": "Profundidade por canal",
  "sensors.heatStressExtreme": "Stress térmico extremo",
  "sensors.heatStressModerate": "Stress térmico moderado",
  "sensors.heatStressNone": "Sem stress térmico",
  "sensors.heatStressStrong": "Stress térmico forte",
  "sensors.heatStressVeryStrong": "Stress térmico muito forte",
  "sensors.humidityByChannel": "Humidade por canal",
  "sensors.indoorAirQuality": "Qualidade do ar interior",
  "sensors.indoorAirQualityPm": "PM2.5 e PM10 AQI",
  "sensors.indoorClimate": "Clima interior",
  "sensors.indoorCo2Levels": "Níveis de CO2",
  "sensors.indoorTemperatureAndHumidity": "Temperatura e humidade",
  "sensors.last24Hours": "24 horas",
  "sensors.last30Days": "30 dias",
  "sensors.last7Days": "7 dias",
  "sensors.leafTemperatureByChannel": "Temperatura das folhas por canal",
  "sensors.leafWetnessByChannel": "Humidade das folhas por canal",
  "sensors.lightningSensor": "Relâmpago",
  "sensors.moistureByChannel": "Humidade do solo por canal",
  "sensors.noDataAvailable": "Sem dados disponíveis",
  "sensors.pm10AndAqi": "PM10 & AQI",
  "sensors.pm1AndAqi": "PM1.0 & AQI",
  "sensors.pm25AndAqi": "PM2.5 & AQI",
  "sensors.pm25ByChannel": "PM2.5 por canal",
  "sensors.pm4AndAqi": "PM4.0 & AQI",
  "sensors.selectChannel": "Selecionar canal",
  "sensors.sensorDetailDescription": "Veja dados históricos e tendências dos canais do sensor.",
  "sensors.sensorHistory": "Histórico do sensor",
  "sensors.soilConductivityByChannel": "Condutividade por canal",
  "sensors.soilTemperatureByChannel": "Temperatura do solo por canal",
  "sensors.strikesToday": "Raios hoje",
  "sensors.temperatureByChannel": "Temperatura por canal",
  "sensors.viewChart": "Ver gráfico",
  "settings.about": "Acerca de",
  "settings.aboutDescription": "Contrato de licença, política de privacidade",
  "settings.account": "Conta",
  "settings.accountDescription": "Perfil, mudança de palavra-passe",
  "settings.accountIntro": "Dados relacionados com a sua conta:",
  "settings.accountSection": "Conta",
  "settings.appearance": "Aparência",
  "settings.appearanceDescription": "Tema e opções de exibição",
  "settings.appVersion": "SmartMixin v{version}",
  "settings.arabic": "árabe",
  "settings.availableServices": "Disponíveis",
  "settings.bulgarian": "búlgaro",
  "settings.cannotDisconnectLastAccount": "Não é possível desconectar o seu único método de login. Por favor, adicione primeiro outro método de login.",
  "settings.catalan": "catalão",
  "settings.changeEmail": "Alterar e-mail",
  "settings.changePassword": "Mudar palavra-passe",
  "settings.chartGestures": "Gestos nos gráficos",
  "settings.chartGesturesDescription": "Deslizar nos gráficos muda o período de tempo, pinçar nos gráficos muda a escala de tempo",
  "settings.connect": "Conectar",
  "settings.connected": "Conectado",
  "settings.connectedAccounts": "Contas conectadas",
  "settings.connectedAccountsDescription": "Apple, Google, Facebook",
  "settings.connectedServices": "Conectados",
  "settings.connectedSince": "Conectado desde {date}",
  "settings.connectionSuccess": "Conta {provider} conectada com sucesso",
  "settings.contactUs": "Contacte-nos",
  "settings.contactUsDescription": "Obtenha ajuda ou envie feedback",
  "settings.croatian": "croata",
  "settings.currentPassword": "Palavra-passe atual",
  "settings.czech": "checo",
  "settings.danish": "dinamarquês",
  "settings.dark": "Tema escuro",
  "settings.dataDisplay": "Exibição de dados",
  "settings.dateAndTime": "Data e hora",
  "settings.disconnect": "Desconectar",
  "settings.disconnectConfirmation": "Tem a certeza de que deseja desconectar a sua conta {provider}?",
  "settings.disconnectionSuccess": "Conta {provider} desconectada com sucesso",
  "settings.donateButton": "Fazer uma doação",
  "settings.donateDescription": "O SmartMixin é desenvolvido por uma pequena equipa. Se o considera útil, pode apoiar o seu desenvolvimento com uma doação única de qualquer valor. É um presente — não altera o seu plano nem desbloqueia nenhum recurso.",
  "settings.donateSuccessBody": "A sua doação ajuda a manter o SmartMixin a funcionar e a melhorá-lo. Agradecemos de verdade.",
  "settings.donateSuccessTitle": "Obrigado pelo seu apoio!",
  "settings.donateTitle": "Apoie o SmartMixin",
  "settings.dutch": "holandês",
  "settings.emailChange": "Alterar endereço de e-mail",
  "settings.emailChangeConfirmation": "Confirmação de alteração de e-mail",
  "settings.emailChangeFailure": "O link de alteração de e-mail é inválido ou expirou.",
  "settings.emailChangeSuccess": "Seu e-mail foi alterado com sucesso para {newEmail}.",
  "settings.emailChangeVerificationSent": "Um e-mail de verificação foi enviado para o seu novo endereço de e-mail. Por favor, verifique sua caixa de entrada e clique no link para confirmar a alteração.",
  "settings.english": "inglês",
  "settings.forecastModelOrderEmpty": "Nenhuma ordem guardada — usamos o GFS por padrão.",
  "settings.forecastModelOrderFreeHint": "Os modelos premium exigem uma subscrição SmartMixin Premium.",
  "settings.forecastModelOrderHelp": "Escolhemos o primeiro modelo da sua lista que cobre cada estação.",
  "settings.forecastModelOrderReset": "Restaurar padrão",
  "settings.forecastModelOrderTitle": "Modelo de previsão padrão",
  "settings.forecastModels": "Modelos de previsão",
  "settings.forecastModelsDescription": "Reordenar por preferência",
  "settings.french": "francês",
  "settings.german": "alemão",
  "settings.gestures": "Gestos",
  "settings.greek": "grego",
  "settings.helpCenter": "Central de ajuda",
  "settings.helpCenterDescription": "Perguntas frequentes e guias",
  "settings.hungarian": "húngaro",
  "settings.integrationsSection": "Integrações",
  "settings.italian": "italiano",
  "settings.japanese": "japonês",
  "settings.korean": "coreano",
  "settings.language": "Idioma",
  "settings.languageDescription": "Idioma preferido",
  "settings.light": "Tema claro",
  "settings.newEmailAddress": "Novo endereço de e-mail",
  "settings.newPassword": "Nova palavra-passe",
  "settings.newPasswordAgain": "Nova palavra-passe outra vez",
  "settings.norwegian": "norueguês",
  "settings.notConnected": "Não conectado",
  "settings.notificationsSection": "Notificações",
  "settings.oldPassword": "Palavra-passe antiga",
  "settings.ongoingNotificationEnabled": "Ativar notificação permanente",
  "settings.ongoingNotificationMetrics": "Métricas exibidas",
  "settings.ongoingNotificationMetricsHint": "Arraste para reordenar as métricas selecionadas",
  "settings.ongoingNotificationPermissionRequired": "É necessária permissão de notificação",
  "settings.ongoingNotificationStation": "Estação meteorológica",
  "settings.passwordChange": "Alterar palavra-passe",
  "settings.polish": "polaco",
  "settings.portuguese": "português",
  "settings.preferencesSection": "Preferências",
  "settings.premium": "Premium",
  "settings.premiumActive": "Ativo",
  "settings.premiumAnnualThenPrice": "Depois 9,99 €/ano",
  "settings.premiumAnnualTrialInfo": "Comece com um período de teste gratuito de {days} dias",
  "settings.premiumCurrentPlan": "Plano atual",
  "settings.premiumDescription": "Gerir a sua subscrição",
  "settings.premiumDownloadApp": "Transfira a aplicação para subscrever:",
  "settings.premiumExpiresOn": "Renova em {date}",
  "settings.premiumFreePlan": "Gratuito",
  "settings.premiumInactive": "Não inscrito",
  "settings.premiumManageWebSubscription": "Faça a gestão da sua subscrição, atualize o método de pagamento ou cancele.",
  "settings.premiumPremiumPlan": "Premium",
  "settings.premiumSubscribeAnnual": "Anual — 9,99 €/ano",
  "settings.premiumSubscribedOn": "Subscrito em {platform}",
  "settings.premiumSubscribeMonthly": "Mensal — 1,99 €/mês",
  "settings.premiumSubscribeOnWeb": "Subscreva agora para desbloquear todas as funcionalidades premium.",
  "settings.premiumSubscriptionSuccess": "A sua subscrição foi ativada! Aproveite todas as funcionalidades premium.",
  "settings.premiumSubscriptionSuccessTitle": "Bem-vindo ao Premium!",
  "settings.premiumWebappNotice": "As subscrições só podem ser adquiridas através da aplicação SmartMixin no iOS ou Android.",
  "settings.privacyPolicy": "Política de privacidade",
  "settings.profile": "Perfil",
  "settings.russian": "russo",
  "settings.serbian": "sérvio",
  "settings.settings": "Definições",
  "settings.slovak": "eslovaco",
  "settings.smallDecimals": "Decimais pequenos",
  "settings.smallDecimalsDescription": "Exibir dígitos decimais num tamanho menor",
  "settings.socialConnectionsIntro": "Vincule as suas contas sociais para um login rápido. Pode conectar ou desconectar contas a qualquer momento.",
  "settings.spanish": "espanhol",
  "settings.statusBarWidget": "Widget da barra de status",
  "settings.statusBarWidgetDescription": "Dados meteorológicos sempre visíveis",
  "settings.subscriptionSection": "Subscrição",
  "settings.supportSection": "Suporte",
  "settings.swedish": "sueco",
  "settings.systemTheme": "Tema do sistema",
  "settings.termsOfService": "Condições de utilização",
  "settings.turkish": "turco",
  "settings.ukrainian": "ucraniano",
  "settings.units": "Unidades",
  "settings.unitsDescription": "Unidades de medida exibidas na aplicação",
  "settings.update": "Atualização",
  "settings.updateYourProfile": "Atualizar o seu perfil",
  "settings.weatherServices": "Serviços meteorológicos",
  "settings.weatherServicesConnected": "{count, plural, =0 {Nenhum serviço conectado} one {# serviço conectado} other {# serviços conectados}}",
  "settings.weatherServicesDescription": "Conecte Netatmo, Davis, Weatherflow e mais",
  "settings.windDirectionConvention": "Seta de direção do vento",
  "settings.windDirectionConventionDescription": "Escolha como as setas de direção do vento são exibidas",
  "settings.windDirectionMeteorological": "Direção de origem",
  "settings.windDirectionMeteorologicalDescription": "A seta indica de onde o vento vem (convenção meteorológica)",
  "settings.windDirectionOceanographic": "Direção do fluxo",
  "settings.windDirectionOceanographicDescription": "A seta indica para onde o vento sopra (convenção oceanográfica)",
  "units.absolutePressure": "Pressão absoluta",
  "units.airDensity": "Densidade do ar",
  "units.airGap": "Espaço de ar",
  "units.apparentTemperature": "Temperatura aparente",
  "units.AQI": "AQI",
  "units.AQI_24H": "24h AQI",
  "units.avg": "Med.",
  "units.beaufort": "Beaufort",
  "units.blackGlobeTemperature": "Temp. globo negro",
  "units.boilerOn": "Em aquecimento",
  "units.co2": "CO2",
  "units.conductivity": "Condutividade",
  "units.coolingDegreeDays": "Dias de arrefecimento da temperatura",
  "units.dailyHeatingDuration": "Duração do aquecimento diário",
  "units.dailyPrecipitation": "Precipitação diária",
  "units.dailyRain": "Chuva diária",
  "units.degreeDay": "Grau-dia",
  "units.degreeDayShort": "DJU",
  "units.depth": "Profundidade",
  "units.depthSensors": "Sensores de profundidade",
  "units.dewPoint": "Ponto de orvalho",
  "units.distance": "Distância",
  "units.downTrend": "tendência descendente",
  "units.E": "E",
  "units.E_long": "Este",
  "units.ENE": "ENE",
  "units.ENE_long": "este-nordeste",
  "units.ESE": "ESE",
  "units.ESE_long": "este-sudeste",
  "units.ET": "Evapotranspiração",
  "units.ETshort": "E",
  "units.feelLike": "Sente-se",
  "units.feelsLike": "Sente-se",
  "units.footMile": "Pé, milha",
  "units.frostPoint": "ponto de geada",
  "units.gust": "Rajada de vento",
  "units.heatIndex": "Índice de calor",
  "units.heatingDegreeDays": "Dias de aquecimento da temperatura",
  "units.heatingPower": "Potência de aquecimento",
  "units.humidex": "Humidex",
  "units.humidity": "Humidade",
  "units.inch": "Polegada",
  "units.inchOfMercury": "Polegada de mercúrio",
  "units.kilometerPerHour": "Quilómetro por hora",
  "units.knot": "Nó",
  "units.last12Hours": "Últimas 12 horas",
  "units.last24Hours": "Últimas 24 horas",
  "units.last3Hours": "Últimas 3 horas",
  "units.last6Hours": "Últimas 6 horas",
  "units.lastHour": "Última hora",
  "units.lastLightningImpact": "Último raio",
  "units.lastMeasure": "Última medição",
  "units.leafSensors": "Sensores de humidade",
  "units.leafWetness": "Folha molhada",
  "units.lightningDistance": "Distância",
  "units.lightningStrikeCount": "Número de raios",
  "units.lightningStrikeDistance": "Distância do raio",
  "units.max": "Máx.",
  "units.max_gust": "Rajada máx.",
  "units.max_wind": "Vento máx.",
  "units.meterKilometer": "Metro, quilómetro",
  "units.meterPerSecond": "Metro por segundo",
  "units.milePerHour": "Milha por hora",
  "units.millibar": "Milibar",
  "units.millimeter": "Milimetro",
  "units.millimeterOfMercury": "Milímetro de mercúrio",
  "units.min": "Mín.",
  "units.N": "N",
  "units.N_long": "norte",
  "units.NE": "NE",
  "units.NE_long": "nordeste",
  "units.NNE": "NNE",
  "units.NNE_long": "norte-nordeste",
  "units.NNW": "NNO",
  "units.NNW_long": "norte-noroeste",
  "units.noise": "Ruído",
  "units.normalizedHeatingCoefficient": "Coeficiente de aquecimento normalizado",
  "units.NW": "NO",
  "units.NW_long": "noroeste",
  "units.O3": "Ozone",
  "units.PM_1": "PM 1",
  "units.PM_10": "PM 10",
  "units.PM_2P5": "PM 2.5",
  "units.precipitation": "Precipitações",
  "units.pressure": "Pressão atmosférica",
  "units.rain": "Chuva",
  "units.rainRate": "Intensidade de chuva",
  "units.referenceTemperature": "Temperatura de referência",
  "units.relativePressure": "pressão relativa",
  "units.S": "S",
  "units.S_long": "sul",
  "units.SE": "SE",
  "units.SE_long": "Sudeste",
  "units.setPoint": "Ponto de ajuste",
  "units.snow": "Neve",
  "units.snowfall": "Queda de neve",
  "units.soilMoisture": "Humidade do solo",
  "units.soilSensors": "Sensores de solo",
  "units.solarEnergy": "Energia solar",
  "units.solarRadiation": "Radiação solar",
  "units.speed": "Velocidade",
  "units.SSE": "SSE",
  "units.SSE_long": "sul-sudeste",
  "units.SSW": "SSO",
  "units.SSW_long": "sul-sudoeste",
  "units.stableTrend": "tendência estável",
  "units.sum": "Soma",
  "units.SW": "SO",
  "units.SW_long": "Sudoeste",
  "units.temperature": "Temperatura",
  "units.temperatureAndHumiditySensors": "Sensores de temperatura/humidade",
  "units.temperatureSensors": "Sensores de temperatura/humidade",
  "units.thsw": "THSW",
  "units.thw": "THW",
  "units.today": "Hoje",
  "units.upTrend": "tendência de alta",
  "units.uv": "UV",
  "units.visibility": "Visibilidade",
  "units.W": "O",
  "units.W_long": "oeste",
  "units.wetBulbGlobeTemperature": "Temp. bolbo húmido",
  "units.wetBulbTemperature": "Temp. bolbo húmido",
  "units.wind": "Vento",
  "units.windChill": "Resfriamento do Vento",
  "units.windDirection": "Direção do vento",
  "units.windRun": "curso do vento",
  "units.windRunDescription": "A viagem do vento é a distância total percorrida pelo vento durante um período de tempo",
  "units.WNW": "ONO",
  "units.WNW_long": "oeste-noroeste",
  "units.WSW": "OSO",
  "units.WSW_long": "oeste-sudoeste"
}
